export const EqualTrafficConfig: Record<number, number> = (() => {
  try {
    return JSON.parse(process.env.REACT_APP_EQUAL_TRAFFIC_CONFIG || '{}');
  } catch (error) {
    console.error('Invalid EqualTrafficConfig in env:', error);
    return {};
  }
})();
